import type { CallSettingResponse } from '@like-aiop/backend/src/api/call-setting/types';

export { type Honbu, HONBU_LABEL } from '../../shared/honbu';

interface JobNumberItemBase {
  id: string;
  jobNumber: string;
}

export interface EditingJobNumberItem extends JobNumberItemBase {
  status: 'editing';
}

export interface CommittedJobNumberItem extends JobNumberItemBase {
  status: 'committed';
}

export type JobNumberItem = EditingJobNumberItem | CommittedJobNumberItem;

// 広告コード単位の架電スケジュール。曜日別の時間帯に加え、祝日・年末年始(12/29〜1/3)に
// 架電するかどうかを保持する。祝日かどうかの判定はバックエンド側のカレンダーに委ねる。
// 型はバックエンドのレスポンス型から導出し、API 契約のフィールド追加・改名時の静かな乖離を防ぐ。
export type CallSchedule = CallSettingResponse['schedule'];
export type Schedule = CallSchedule['weekdays'];
export type Weekday = keyof Schedule;
export type TimeRange = Schedule[Weekday];

// 曜日の表示順。バックエンドのコードをバンドルに含めないためランタイム値はフロントで定義し、
// 値域は導出型 Weekday で API 契約（schema.prisma の enum Weekday と同値・同順）に固定する。
export const WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const satisfies readonly Weekday[];

export const WEEKDAY_LABEL: Record<Weekday, string> = {
  monday: '月',
  tuesday: '火',
  wednesday: '水',
  thursday: '木',
  friday: '金',
  saturday: '土',
  sunday: '日',
};

export interface ScheduleState {
  current: CallSchedule;
  baseline: CallSchedule;
}

// 設定の単位となる広告コード単位の即架電設定。1件の広告コードに複数の仕事Noがぶら下がり、
// 稼働時間も広告コード単位で設定する。id は書き込み系エンドポイントのパスパラメータに用いる
// （koukokuCode はスラッシュを含みパスパラメータに使えないため）。
// バックエンドのレスポンス型の別名とすることで、フィールド追加時の静かな乖離を防ぐ。
export type CallSetting = CallSettingResponse;
